type TransmissionTypeSelectorProps = {
  value: string
  errorMessage: string | null
  disabled?: boolean
  onChange: (value: 'manual' | 'automatic') => void
}

export function TransmissionTypeSelector({
  value,
  errorMessage,
  disabled = false,
  onChange
}: TransmissionTypeSelectorProps) {
  return (
    <div className="animate-fade-in-up" style={{ animationDelay: '120ms' }}>
      <label className="mb-2 block text-md  text-gray-dark">
        What type of transmission would you like to train on?
        <span className="ml-1 text-red-500">*</span>
      </label>
      <div className="mt-2 flex gap-8">
        {[
          { label: 'Manual', value: 'manual' },
          { label: 'Automatic', value: 'automatic' }
        ].map(option => (
          <label key={option.value} className="flex cursor-pointer select-none items-center gap-2">
            <input
              type="radio"
              name="transmissionType"
              checked={value === option.value}
              disabled={disabled}
              onChange={() => onChange(option.value as 'manual' | 'automatic')}
              className="shrink-0"
            />
            <span className="text-base font-medium text-gray-900">{option.label}</span>
          </label>
        ))}
      </div>
      {errorMessage ? <p className="mt-2 text-sm text-red-600">{errorMessage}</p> : null}
    </div>
  )
}
